<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-2"></div>
      <div class="col-sm-3">
        <button
          type="button"
          class="btn btn-success btn-block"
          @click="getReport"
        >
          <i class="fas fa-redo"></i> ประมวลผล
        </button>
      </div>
      <div class="col-sm-3">
        <form
          action="/static/pdf/report_sale_summary.php"
          method="POST"
          target="_blank"
        >
          <input
            type="hidden"
            name="date_start"
            v-model="startDate"
          >
          <input
            type="hidden"
            name="date_end"
            v-model="endDate"
          >
          <input
            type="hidden"
            name="host"
            v-model="form_host"
          >
          <input
            type="hidden"
            name="data"
            v-model="form_data"
          >
          <button
            type="submit"
            :disabled="report_data.length < 1"
            class="btn btn-primary btn-block"
          >
            <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
          </button>
        </form>
      </div>
      <div class="col-sm-3">
        <form
          action="/static/excel/report_sale_summary.php"
          method="POST"
          target="_blank"
        >
          <input
            type="hidden"
            name="date_start"
            v-model="startDate"
          >
          <input
            type="hidden"
            name="date_end"
            v-model="endDate"
          >
          <input
            type="hidden"
            name="host"
            v-model="form_host"
          >
          <input
            type="hidden"
            name="data"
            v-model="form_data"
          >
          <button
            type="submit"
            :disabled="report_data.length < 1"
            class="btn btn-info btn-block"
          >
            <i class="far fa-file-excel"></i> บันทึกเป็น Excel
          </button>
        </form>
      </div>
      <div class="col-sm-2"></div>
    </div>
    <div
      class="table-responsive-sm mt-3"
      v-for="(s, i) in report_data"
      :key="'datar' + i"
    >
      <table class="table" v-if="s.length > 0">
        <thead>
          <tr
            class="text-left"
            style="font-size: 18px; font-weight: bold;"
          >
            <td colspan="4">สาขา: {{ s[0].branch_name?s[0].branch_name: '-' }}</td>
            <td colspan="4">จุดขาย: {{ host.host_name }}</td>
          </tr>
        </thead>
        <tbody>
          <tr class="thead-dark text-center">
            <th>วันที่</th>
            <th width="10%" class="text-right">จำนวนใบเสร็จ</th>
            <th width="10%" class="text-right">จำนวนสินค้า</th>
            <th width="10%" class="text-right">ราคารวม</th>
            <th width="10%" class="text-right">ส่วนลด</th>
            <th width="15%" class="text-right">สินค้ายกเว้น VAT</th>
            <th width="15%" class="text-right">สินค้ามี VAT</th>
            <th width="15%" class="text-right">ภาษีมูลค่าเพิ่ม 7%</th>
            <th width="20%" class="text-right">ราคาสุทธิ</th>
          </tr>
          <tr
            v-for="(r, i) in s"
            :key="'datab' + i"
          >
            <td class="text-center">{{ dateFormatDMY(r.doc_date) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.bill_count) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.count_item) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.item_amount) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.discount_amount) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.price_product_not_tax) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.price_product_tax - r.cal_product_tax) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.cal_product_tax) }}</td>
            <td class="text-right">{{ numberFormatDecimal(r.price_product_not_tax + (r.price_product_tax)) }}</td>
          </tr>
          <tr v-if="s.length !== 0">
            <th
              colspan="8"
              class="text-right"
            >### รวมรายการสินค้าจำนวน: {{ s.length }} ###</th>
          </tr>
          <tr v-if="s.length !== 0">
            <th class="text-center">รวมรายการจุดขาย : {{ host.host_name }}</th>
            <th class="text-right">{{ numberFormatDecimal(bill_count(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(count_item(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(item_amount(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(discount_amount(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(price_product_not_tax(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(price_product_tax(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(cal_product_tax(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(total_amount(s)) }}</th>
          </tr>
          <tr
            class="thead-dark"
            v-if="s.length !== 0"
          >
            <th class="text-center">รวมสาขา {{ s[0].branch_name?s[0].branch_name: '-' }}</th>
            <th class="text-right">{{ numberFormatDecimal(bill_count(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(count_item(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(item_amount(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(discount_amount(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(price_product_not_tax(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(price_product_tax(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(cal_product_tax(s)) }}</th>
            <th class="text-right">{{ numberFormatDecimal(total_amount(s)) }}</th>
          </tr>
        </tbody>
        <tr
          v-if="s.length === (i - 1)"
          style="font-size: 20px; background: #f2f2f2;"
        >
          <th>รวมทุกสาขา</th>
          <th class="text-right">{{ numberFormatDecimal(sum_bill_count(report_data)) }}</th>
          <th class="text-right">{{ numberFormatDecimal(sum_count_item(report_data)) }}</th>
          <th class="text-right">{{ numberFormatDecimal(sum_item_amount(report_data)) }}</th>
          <th class="text-right">{{ numberFormatDecimal(sum_discount_amount(report_data)) }}</th>
          <th class="text-right">{{ numberFormatDecimal(sum_price_product_not_tax(report_data)) }}</th>
          <th class="text-right">{{ numberFormatDecimal(sum_price_product_tax(report_data)) }}</th>
          <th class="text-right">{{ numberFormatDecimal(sum_cal_product_tax(report_data)) }}</th>
          <th class="text-right">{{ numberFormatDecimal(sum_total_amount(report_data)) }}</th>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import api from '../../services/service_report'
import apiCenterV2 from "../../services/service_undefined_v2";

export default {
  props: ['host', 'startDate', 'endDate', 'branch'],
  data () {
    return {
      report_data: [],
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      form_host: JSON.stringify(this.host)
    }
  },
  methods: {
    test () {
      console.log(this.form_data)
    },
    getReport () {
      this.report_data = {}
      var branch = 0
      if (this.branch !== 0) {
        branch = this.branch.id
      }
      var obj = {
        host_code: this.host.host_code,
        company_id: this.$store.state.company_id,
        branch_id: 1,
        id: branch,
        begin_date: this.dateFormatDMY2(this.startDate),
        end_date: this.dateFormatDMY2(this.endDate)
      }
      this.$store.commit('Loading')
      api.saleSummary(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
  
          if (result.response === 'success') {


            var obj = {
              start_date: this.dateFormatDMY2(this.startDate), // Set formatted start date
              end_date: this.dateFormatDMY2(this.endDate), // Set formatted end date
              branch_id: branch,
            };

            apiCenterV2.reportsSaleSummery(
              obj,
              this.header,
              results => {
                // this.$store.state.isLoading = false
                if (results.status) {
                  this.$store.commit('Loading')
                  console.log(result.data);
                  this.report_data = result.data
                  result.data.map((e) => {
                    e.map((ex) => {

                      const branchData = results.data.data.find(b => b.branch_id === branch);

                      if (branchData) {
                        const exDate = new Date(new Date(ex.doc_date).getTime() + 24 * 60 * 60 * 1000)
                        .toISOString()
                        .split("T")[0];

                        const match = branchData.results.find(e => e.doc_date === exDate);
                        // console.log("doc_date", e.doc_date);
                        console.log("exDate", exDate);
                        console.log(match);
                        if (match) {
                          console.log(ex.total_amount)
                          ex.total_amount -= match.amount;
                          ex.price_product_not_tax -= match.amount;
                          ex.item_amount -= match.amount;
                          console.log(ex.total_amount)
                        }
                      }

       
                      if(ex.branch_name === 'สาขาธานินท์'){
                        ex.branch_name = 'สาขาธานินท์ ' + '(00001)'
                      } else if (ex.branch_name === 'สาขาต้นพยอม') {
                        ex.branch_name = 'สาขาต้นพยอม ' + '(00002)'
                      }else if (ex.branch_name === 'สาขาจอมทอง') {
                        ex.branch_name = 'สาขาจอมทอง ' + '(00003)'
                      }else if (ex.branch_name === 'สาขาบ่อสร้าง') {
                        ex.branch_name = 'สาขาบ่อสร้าง ' + '(00004)'
                      }else if (ex.branch_name === 'สาขาป่าเหมือด') {
                        ex.branch_name = 'สาขาป่าเหมือด ' + '(00005)'
                      }else if (ex.branch_name === 'สาขาศรีบุญยืน') {
                        ex.branch_name = 'สาขาศรีบุญยืน ' + '(00006)'
                      }else if (ex.branch_name === 'สาขาหนองกระทิง') {
                        ex.branch_name = 'สาขาหนองกระทิง ' + '(00007)'
                      }else  {
                        ex.branch_name = ex.branch_name + ' (00000)'
                      }
                    });
                  });

                  var data = []
                  result.data.forEach(v => {
                    if (v.length > 0) {
                      data.push(v)
                    }
                  })
                  this.form_data = JSON.stringify(data)

                } else {
                  this.$store.commit('Loading')
                  this.$notification['warning']({
                    message: 'ดึงข้อมูลรายงานไม่ได้',
                    description: results.message
                  })
                }
              },
              errors => {
                this.$store.commit('Loading')
                // this.$store.commit("Loading");
                this.$notification["warning"]({
                  message: "ไม่สามารถเข้าถึงข้อมูลได้",
                  description: errors.data.message
                });
              }
            );
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    bill_count (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['bill_count']
      })
      return sum
    },
    item_amount (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['item_amount']
      })
      return sum
    },
    discount_amount (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['discount_amount']
      })
      return sum
    },
    before_tax_amount (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['before_tax_amount']
      })
      return sum
    },
    tax_amount (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['tax_amount']
      })
      return sum
    },
    total_amount (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['price_product_not_tax'] + (val['price_product_tax'])
      })
      return sum
    },
    count_item (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['count_item']
      })
      return sum
    },
    sum_bill_count (obj) {
      var sum = 0
      obj.forEach(v => {
        v.forEach(val => {
          sum += val['bill_count']
        })
      })
      return sum
    },
    sum_discount_amount (obj) {
      var sum = 0
      obj.forEach(v => {
        v.forEach(val => {
          sum += val['discount_amount']
        })
      })
      return sum
    },
    sum_total_amount (obj) {
      var sum = 0
      obj.forEach(v => {
        v.forEach(val => {
          sum += val['price_product_not_tax'] + (val['price_product_tax'])
        })
      })
      return sum
    },
    sum_count_item (obj) {
      var sum = 0
      obj.forEach(v => {
        v.forEach(val => {
          sum += val['count_item']
        })
      })
      return sum
    },
    sum_item_amount (obj) {
      var sum = 0
      obj.forEach(v => {
        v.forEach(val => {
          sum += val['item_amount']
        })
      })
      return sum
    },
    cal_product_tax (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['cal_product_tax']
      })
      return sum
    },
    price_product_tax (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['price_product_tax'] - val['cal_product_tax']
      })
      return sum
    },
    price_product_not_tax (obj) {
      var sum = 0
      obj.forEach(val => {
        sum += val['price_product_not_tax']
      })
      return sum
    },
    sum_cal_product_tax (obj) {
      var sum = 0
      obj.forEach(v => {
        v.forEach(val => {
          sum += val['cal_product_tax']
        })
      })
      return sum
    },
    sum_price_product_tax (obj) {
      var sum = 0
      obj.forEach(v => {
        v.forEach(val => {
          sum += val['price_product_tax'] - val['cal_product_tax']
        })
      })
      return sum
    },
    sum_price_product_not_tax (obj) {
      var sum = 0
      obj.forEach(v => {
        v.forEach(val => {
          sum += val['price_product_not_tax']
        })
      })
      return sum
    },
  },
  mounted () {
    // setTimeout(() => {
    //   this.getReport()
    // }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/report/report_sale_summary.vue